const STORAGE_KEY = "baback-sse-connection-id";

export const SSE_CONNECTION_ID_HEADER = "x-sse-connection-id";

const generateConnectionId = () =>
  globalThis.crypto?.randomUUID?.() ?? Math.random().toString(36).slice(2);

export const getSseConnectionId = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const existing = sessionStorage.getItem(STORAGE_KEY);

    if (existing) {
      return existing;
    }

    const nextId = generateConnectionId();
    sessionStorage.setItem(STORAGE_KEY, nextId);
    return nextId;
  } catch (error) {
    console.error("Unable to persist SSE connection ID", error);
    return null;
  }
};
